import { render, staticRenderFns } from "./DateTableView.vue?vue&type=template&id=06b55975&scoped=true"
import script from "./DateTableView.vue?vue&type=script&lang=js"
export * from "./DateTableView.vue?vue&type=script&lang=js"
import style0 from "./DateTableView.vue?vue&type=style&index=0&id=06b55975&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b55975",
  null
  
)

export default component.exports